import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Composable for timer logic with automatic interval management.
 *
 * @param {number} initialSeconds - Initial timer value in seconds
 */
export function useTimer(initialSeconds = 0) {
    const startTime = ref(Date.now() - initialSeconds * 1000)
    const timer = ref(initialSeconds)
    let intervalId = null

    const resetTimer = () => {
        startTime.value = Date.now()
        timer.value = 0
    }

    const syncWithServer = (serverSeconds) => {
        startTime.value = Date.now() - serverSeconds * 1000
        timer.value = serverSeconds
    }

    onMounted(() => {
        intervalId = setInterval(() => {
            timer.value = Math.floor((Date.now() - startTime.value) / 1000)
        }, 1000)
    })

    onUnmounted(() => {
        clearInterval(intervalId)
    })

    return {
        timer,
        startTime,
        resetTimer,
        syncWithServer,
    }
}
